import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const busServices = createApi({
  reducerPath: "busServices",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
  }),
  endpoints: (builder) => ({
    getOperatorList: builder.query({
      query: () => ({
        url: "/api/operatorlist.php",
        method: "GET",
      }),
      providesTags: ["busOperations"],
    }),
    getFacilityList: builder.query({
      query: () => ({
        url: "/api/facilitylist.php",
        method: "GET",
      }),
      providesTags: ["busOperations"],
    }),
  }),
  tagTypes: ["busOperations"],
});

export const { useGetOperatorListQuery, useGetFacilityListQuery } = busServices;

export default busServices;
